module.exports = require('./helpers/bundle-url').getBundleURL('9rAa3') + "check-your-email-open-letter.58fc87ea.svg";